/* SORSO cart drawer extras (2026-09-08, gift guard 2026-09-09): upsell add, second-unit ladder (SOLO→FRIENDS→FAMILY), discount code, gift guard. */
(function () {
  function drawer() { return document.querySelector('cart-drawer'); }
  // SORSO 2026-09-09 gift guard. The gift app (EasyGift) adds the free gifts with its own /cart/add at the same
  // moment the theme adds the product; Shopify's two concurrent cart writes race and ~1 in 23 orders shipped with
  // the aerator and NO gift lines. This reads the gift rules EasyGift itself publishes on the page
  // (<meta id="easygift-rules">), waits for the writes to settle, and re-adds any expected gift that is missing,
  // with the `_Gifted` line property the app's discount keys on. Never touches paid lines; one repair per call.
  if (!window.sorsoGiftGuard) {
    const GH = { 'Content-Type': 'application/json', Accept: 'application/json' };
    const settle = (ms) => new Promise((r) => setTimeout(r, ms));
    const readCart = () => fetch(`${window.routes.cart_url}.js`, { cache: 'no-store' }).then((r) => r.json());
    const expected = (variantId) => {
      try {
        const meta = document.getElementById('easygift-rules'); if (!meta) return [];
        const rules = JSON.parse(meta.content || '[]'); const out = [];
        rules.forEach((r) => {
          if (!r || r.active === false || r.testMode) return;
          const t = r.trigger || {}; if (t.type !== 'productsInclude') return;
          if (!(t.products || []).some((p) => String(p.variantId) === String(variantId))) return;
          const a = r.action || {}; if (a.type !== 'addAutomatically') return;
          (a.products || []).forEach((p) => { if (p && p.variantId) out.push({ id: Number(p.variantId), rule: r.name }); });
        });
        return out;
      } catch (e) { return []; }
    };
    // Full reconcile of the gift lines against the rules whose trigger is in the cart. Runs only after the theme's own
    // add / tier swap (never on a timer), so it cannot fight the app. Fixes three classes: (1) gift lost to the write race
    // → re-add; (2) gift tagged with a rule whose trigger left the cart (tier swap) → re-tag so the discount applies;
    // (3) gift line with no trigger in the cart (orphan, would be charged full price) → remove. Paid lines are never touched.
    const rulesFor = () => { try { const m = document.getElementById('easygift-rules'); const rs = m ? JSON.parse(m.content || '[]') : []; return rs.filter((r) => r && r.active !== false && !r.testMode && (r.trigger || {}).type === 'productsInclude' && (r.action || {}).type === 'addAutomatically'); } catch (e) { return []; } };
    const cartWrite = (path, body) => fetch(`${window.routes.cart_url}/${path}.js`, { method: 'POST', headers: GH, body: JSON.stringify(body) }).then((r) => r.json());
    const reconcile = (cart, ropts) => {
      const addMissing = !(ropts && ropts.addMissing === false);
      const items = cart.items || []; const present = new Set(items.map((i) => String(i.variant_id)));
      const rules = rulesFor(); if (!rules.length) return Promise.resolve({ checked: false, repaired: 0 });
      const active = rules.filter((r) => (r.trigger.products || []).some((p) => present.has(String(p.variantId))));
      const wanted = {}; // giftVariantId → [rule names whose trigger is in the cart]
      active.forEach((r) => (r.action.products || []).forEach((p) => { if (!p || !p.variantId) return; (wanted[String(p.variantId)] = wanted[String(p.variantId)] || []).push(r.name); }));
      const giftLines = items.filter((i) => i.properties && i.properties._Gifted);
      const stale = giftLines.filter((i) => wanted[String(i.variant_id)] && wanted[String(i.variant_id)].indexOf(i.properties._Gifted) < 0);
      const orphan = giftLines.filter((i) => !wanted[String(i.variant_id)]);
      const missing = addMissing ? Object.keys(wanted).filter((id) => !present.has(id)).map((id) => ({ id: Number(id), rule: wanted[id][0] })) : [];
      if (!stale.length && !orphan.length && !missing.length) return Promise.resolve({ checked: true, repaired: 0 });
      let chain = Promise.resolve();
      stale.concat(orphan).forEach((i) => { chain = chain.then(() => cartWrite('change', { id: i.key, quantity: 0 })).catch(() => {}); });
      const adds = missing.concat(stale.map((i) => ({ id: Number(i.variant_id), rule: wanted[String(i.variant_id)][0] })));
      if (adds.length) chain = chain.then(() => cartWrite('add', { items: adds.map((g) => ({ id: g.id, quantity: 1, properties: { _Gifted: g.rule } })) })).catch(() => {});
      return chain.then(() => settle(400)).then(readCart).then((c2) => {
        const now = new Set((c2.items || []).map((i) => String(i.variant_id)));
        const repaired = adds.filter((g) => now.has(String(g.id))).length + orphan.length;
        try { (window.dataLayer = window.dataLayer || []).push({ event: 'sorso_gift_guard', repaired, stale: stale.length, orphan: orphan.length, missing: missing.length }); } catch (e) { }
        return { checked: true, repaired, stale: stale.length, orphan: orphan.length, missing: missing.length };
      });
    };
    // ensure(variantId): wait for the concurrent writes to settle, then reconcile. Skips when the product itself is not in
    // the cart (the caller handles that case). Resolves to { repaired, checked, missingProduct }.
    const ensure = (variantId, opts) => {
      const o = Object.assign({ settleMs: 600 }, opts || {});
      return settle(o.settleMs).then(readCart).then((cart) => {
        if (variantId && !(cart.items || []).some((i) => String(i.variant_id) === String(variantId))) return { repaired: 0, checked: true, missingProduct: true };
        return reconcile(cart);
      }).catch(() => ({ repaired: 0, checked: false, error: true }));
    };
    window.sorsoGiftGuard = { expected, ensure, reconcile: (ropts) => readCart().then((c) => reconcile(c, ropts)) };
  }
  const H = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  function rerenderFromCart() {
    // Re-fetch the drawer + icon sections and paint them (used after multi-step cart edits).
    return fetch(`${window.routes.cart_url}?sections=cart-drawer,cart-icon-bubble`, { cache: 'no-store' })
      .then(r => r.json())
      .then(sections => { const d = drawer(); if (d) d.renderContents({ sections }); if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-extras' }); });
  }
  function addVariant(id, qty) {
    return fetch(window.routes.cart_add_url, { method: 'POST', headers: H, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }) }).then(r => r.json());
  }
  if (window.subscribe && window.PUB_SUB_EVENTS && window.sorsoGiftGuard) {
    let giftTimer = null;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
      if (ev && (ev.source === 'cart-drawer-extras' || ev.source === 'product-form')) return;
      clearTimeout(giftTimer);
      giftTimer = setTimeout(() => { window.sorsoGiftGuard.reconcile({ addMissing: false }).then(g => { if (g && g.repaired) rerenderFromCart(); }).catch(() => {}); }, 1500);
    });
  }
  if (!customElements.get('cart-upsell-add')) {
    customElements.define('cart-upsell-add', class extends HTMLElement {
      connectedCallback() {
        const btn = this.querySelector('button'); if (!btn || btn.dataset.bound) return; btn.dataset.bound = '1';
        btn.addEventListener('click', () => {
          btn.classList.add('is-loading');
          addVariant(this.dataset.variantId, 1).then(res => {
            if (res.status) { btn.classList.remove('is-loading'); btn.textContent = res.description || 'Unavailable'; return; }
            const d = drawer(); if (d && res.sections) d.renderContents(res);
            if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-extras', cartData: res });
            setTimeout(rerenderFromCart, 1800);
          }).catch(() => btn.classList.remove('is-loading'));
        });
      }
    });
  }
  if (!customElements.get('cart-ladder-upgrade')) {
    // Swaps the Sorso line to the next bundle tier: add the new variant, then remove the old line by key.
    customElements.define('cart-ladder-upgrade', class extends HTMLElement {
      connectedCallback() {
        const btn = this.querySelector('button'); if (!btn || btn.dataset.bound) return; btn.dataset.bound = '1';
        btn.addEventListener('click', () => {
          btn.classList.add('is-loading');
          const key = this.dataset.lineKey, addId = this.dataset.addId;
          // 2026-09-09: remove the old tier FIRST so the gift app's reverse pass takes its gifts, then add the new tier so the
          // app adds that tier's gifts fresh. (Adding first left duplicate gift lines that the app de-duped wrongly → the old
          // tier's gifts survived as PAID lines.) The Checkout button stays disabled until the single repaint below.
          const chk = document.getElementById('CartDrawer-Checkout'); if (chk) chk.disabled = true;
          const oldVariantId = Number((key || '').split(':')[0]);
          fetch(window.routes.cart_change_url, { method: 'POST', headers: H, body: JSON.stringify({ id: key, quantity: 0 }) })
            .then(r => r.json())
            .then(() => fetch(window.routes.cart_add_url, { method: 'POST', headers: H, body: JSON.stringify({ items: [{ id: Number(addId), quantity: 1 }] }) }))
            .then(r => r.json())
            .then(res => { if (res.status) { return fetch(window.routes.cart_add_url, { method: 'POST', headers: H, body: JSON.stringify({ items: [{ id: oldVariantId, quantity: 1 }] }) }).then(() => { throw new Error(res.description || 'add failed'); }); } return res; })
            // gift guard (2026-09-09): after the swap EasyGift's dedupe leaves the OLD tier's gift lines behind and, once the
            // old tier is gone, they turn into PAID lines. Reconcile against the rules first, then paint ONCE.
            .then(() => (window.sorsoGiftGuard ? window.sorsoGiftGuard.ensure(addId, { settleMs: 800 }) : null))
            .then(() => rerenderFromCart())
            .catch(err => { btn.classList.remove('is-loading'); btn.textContent = (err && err.message) || 'Try again'; });
        });
      }
    });
  }
  if (!customElements.get('cart-discount-form')) {
    customElements.define('cart-discount-form', class extends HTMLElement {
      connectedCallback() {
        const input = this.querySelector('input'), btn = this.querySelector('button'), msg = this.querySelector('.sw-discount__msg');
        if (!input || !btn || btn.dataset.bound) return; btn.dataset.bound = '1';
        const saved = sessionStorage.getItem('sw_discount');
        if (saved) { input.value = saved; msg.hidden = false; msg.textContent = 'Code ' + saved + ' will be applied at checkout'; }
        const apply = () => {
          const code = (input.value || '').trim(); if (!code) return; btn.disabled = true;
          fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'follow' })
            .then(() => { sessionStorage.setItem('sw_discount', code); msg.hidden = false; msg.classList.remove('is-error'); msg.textContent = 'Code ' + code.toUpperCase() + ' will be applied at checkout'; })
            .catch(() => { msg.hidden = false; msg.classList.add('is-error'); msg.textContent = 'Could not apply that code'; })
            .finally(() => { btn.disabled = false; });
        };
        btn.addEventListener('click', apply);
        input.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
      }
    });
  }
})();
